import http from './ajax';

const API_URL = {
  activityUrl: '/Activity',
  activitiesUrl: '/Activities',
  calendarUrl: '/Calendar',
};

class ActivityApi extends http {
  // eslint-disable-next-line no-unused-vars
  getAllActivity = async (params) => {
    const url = `${API_URL.activitiesUrl}?count=10&page=${params}`;
    try {
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      return err;
    }
  }

  getMonthActivity = async (params) => {
    const url = `${API_URL.activitiesUrl}/${params}`;
    try {
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      return err;
    }
  }

  getAllAlbums = async (params) => {
    const url = `/Albums?count=10&page=${params}`;
    try {
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      return err;
    }
  }

  getActivityDetail = async (params) => {
    const url = `${API_URL.activityUrl}/${params}`;
    try {
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      return err;
    }
  }

  getAlbumDetail = async (params) => {
    const url = `/Album/${params}`;
    try {
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      return err;
    }
  }

  getActivityCategory = async () => {
    const url = `${API_URL.activityUrl}/Category`;
    try {
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      return err;
    }
  }

  postActivity = async (token, params) => {
    const url = `${API_URL.activityUrl}/Submit`;
    try {
      const response = await this.postRequestWithToken(url, token, params);
      return response;
    } catch (err) {
      return err;
    }
  }

  checkActivity = async (params) => {
    const url = `${API_URL.activityUrl}/Check?number=${params}`;
    try {
      const response = await this.postRequest(url, params);
      return response;
    } catch (err) {
      return err;
    }
  }

  postData = async (Id, params = {}, token) => {
    const url = `${API_URL.activityUrl}/SubmitWithFile/${Id}`;
    try {
      const response = await this.postfileRequest(url, params, token);
      return response;
    } catch (err) {
      return err;
    }
  };

  getFee = async (Id, token) => {
    const url = `${API_URL.activityUrl}/GetActivityFee/${Id}`;
    try {
      const response = await this.getRequestForMember(url, token);
      return response;
    } catch (err) {
      return err;
    }
  };

  getAllFee = async (Id, token) => {
    const url = `${API_URL.activityUrl}/GetAllActivityFee/${Id}`;
    try {
      const response = await this.getRequestForMember(url, token);
      return response;
    } catch (err) {
      return err;
    }
  };

  getTopic = async (Id, token) => {
    const url = `${API_URL.activityUrl}/GetTopics?participantId=${Id}`;
    try {
      const response = await this.getRequestForMember(url, token);
      return response;
    } catch (err) {
      return err;
    }
  };

  uploadTopic = async (params = {}, data, token) => {
    const url = `${API_URL.activityUrl}/UploadSubmission?activityId=${params.activityId}&participantId=${params.participantId}`;
    try {
      const response = await this.postfileRequest(url, data, token);
      return response;
    } catch (err) {
      return err;
    }
  };

  updateSubmission = async (params = {}, token) => {
    const url = `${API_URL.activityUrl}/UpdateSubmission`;
    try {
      const response = await this.postRequest(url, params, token);
      return response;
    } catch (err) {
      return err;
    }
  };

  getInput = async (Id, token) => {
    const url = `${API_URL.activityUrl}/GetParticipantColumn?activityId=${Id}`;
    try {
      const response = await this.getRequestForMember(url, token);
      return response;
    } catch (err) {
      return err;
    }
  };

  getCalendarActivity = async (params) => {
    const url = `${API_URL.calendarUrl}/${params.year}/${params.month}`;
    try {
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      return err;
    }
  }
}

export default new ActivityApi();
